/* Email capture transport.

   Round 4 rewrite. Round 3 submitted these forms into a hidden iframe so the
   page never navigated. That is abandoned. Measured on 2026-08-26: the
   identical failure (hCaptcha calls getcaptcha and the POST to /contact never
   happens) reproduces on this store's PUBLISHED theme, whose newsletter form is
   stock Shopify with no theme JS at all. The iframe was never the cause, and
   owning a custom transport buys nothing but a second thing that can break.

   So: an ordinary full-page POST to /contact#contact_form, exactly as Shopify
   ships it. hCaptcha owns the navigation target, which is the arrangement it is
   built for. `return_to` brings the visitor back to the page they were on with
   ?subscribed=1, and the success state is rendered from that (or from
   form.posted_successfully? in Liquid, if the platform ignores return_to and
   uses ?customer_posted=true instead — both paths are handled).

   What this file still owns is the part the old one got wrong: an IMMEDIATE
   pending state, so the control never sits silent. */
(function () {
  function subscribed() {
    return /[?&]subscribed=1(&|$)/.test(window.location.search);
  }

  /* Drop ?subscribed=1 once it has been read, so a reload or a shared URL does
     not replay a success the visitor did not just cause. */
  function consume() {
    if (!subscribed() || !window.history || !history.replaceState) return;
    var q = window.location.search
      .replace(/([?&])subscribed=1(&|$)/, '$1')
      .replace(/[?&]$/, '');
    history.replaceState(history.state, '', window.location.pathname + q + window.location.hash);
  }

  /* Bind a customer form. The submit event is never cancelled on the happy
     path — cancelling it is what breaks the captcha. */
  function bind(form, opts) {
    if (!form || form.dataset.cmBound === '1') return;
    form.dataset.cmBound = '1';
    opts = opts || {};

    form.setAttribute('novalidate', '');

    form.addEventListener('submit', function (e) {
      var problem = opts.validate ? opts.validate(form) : null;
      if (problem) {
        e.preventDefault();
        if (opts.onError) opts.onError(problem);
        return;
      }
      if (form.dataset.cmSending === '1') {
        e.preventDefault();
        return;
      }
      form.dataset.cmSending = '1';
      if (opts.onSending) opts.onSending();
      /* No preventDefault. The native POST is the point. */
    });
  }

  /* The pending state every one of these forms shares: the label says what is
     happening rather than going grey and silent. */
  function pending(button) {
    if (!button) return;
    button.dataset.cmLabel = button.textContent;
    button.textContent = 'Sending';
    button.disabled = true;
  }

  function restore(button) {
    if (!button || !button.dataset.cmLabel) return;
    button.textContent = button.dataset.cmLabel;
    button.disabled = false;
  }

  /* The theme prints its own hCaptcha attribution because the floating badge
     is hidden in CSS. If Shopify's captcha bundle later injects its own
     attribution into the same form, drop ours rather than say it twice. */
  function dedupeAttribution() {
    var ours = document.querySelectorAll('.consent--attribution');
    if (!ours.length) return;
    var all = document.querySelectorAll('form *');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.classList.contains('consent--attribution')) continue;
      if (el.children.length) continue;
      if (/protected by hcaptcha/i.test(el.textContent || '')) {
        for (var j = 0; j < ours.length; j++) ours[j].hidden = true;
        return;
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(dedupeAttribution, 1200); });
  } else {
    setTimeout(dedupeAttribution, 1200);
  }

  window.CMCapture = {
    bind: bind,
    subscribed: subscribed,
    consume: consume,
    pending: pending,
    restore: restore
  };
})();
